import { GLOSARIO, preguntaDeQueEs, type TerminoGlosario } from '@alexiarest/shared';
import { InfoHint } from './InfoHint';
import { usePreguntarAlexia } from './PreguntarAlexia';
import './queEs.css';

/**
 * El «?» junto a una palabra (Los «?» de Alexia, Alex, 15 oct 2026).
 *
 * Un círculo de 16 px que no mueve nada. Al pasar el ratón, con el foco o al
 * tocar en el teléfono sale qué significa (el texto de Alex, el mismo en
 * todas las pantallas: shared/glosario.ts), debajo `tu` —el número de esa
 * persona («Tú estás justo en el 60 %»)— y al final «Pregúntale a Alexia»,
 * que abre el chat con «¿Qué es «…»?».
 *
 * `palabra`: cuando en esta pantalla la palabra sale de otra forma
 * («Pendiente de pagar» en vez de «Por pagar»), para la pregunta.
 * `extra`: una frase más al final del texto (Materia prima sin recuento).
 */
export function QueEs({ termino, tu, palabra, extra }: {
  termino: TerminoGlosario;
  tu?: string | null;
  palabra?: string;
  extra?: string | null;
}): JSX.Element {
  const entrada = GLOSARIO[termino];
  const preguntar = usePreguntarAlexia();
  const nombre = palabra ?? entrada.palabra;
  const pregunta = preguntaDeQueEs(nombre);
  return (
    <span className="que-es" data-termino={termino}>
      <InfoHint
        text={extra ? `${entrada.texto} ${extra}` : entrada.texto}
        detalle={tu ?? undefined}
        nombre={`Qué es «${nombre}»`}
        alPreguntar={preguntar ? () => preguntar(pregunta) : undefined}
      />
    </span>
  );
}

/**
 * La palabra con su «?» y, si la tiene, la etiqueta técnica en pequeño y gris
 * («Te dejó el negocio EBITDA ?»). Para cabeceras y etiquetas que son solo eso.
 */
export function ConQueEs({ termino, tu, palabra, conSigla = false }: {
  termino: TerminoGlosario;
  tu?: string | null;
  palabra?: string;
  conSigla?: boolean;
}): JSX.Element {
  const entrada = GLOSARIO[termino];
  return (
    <>
      {palabra ?? entrada.palabra}
      {conSigla && entrada.sigla && <span className="que-es__sigla">{entrada.sigla}</span>}
      <QueEs termino={termino} tu={tu} palabra={palabra} />
    </>
  );
}
